"use client";

import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useEffect, useState } from "react";

export function openContentDialog(id: string) {
  window.dispatchEvent(
    new CustomEvent("reweb-open-dialog", { detail: { id } }),
  );
}

export default function ContentDialog({
  id,
  title,
  triggerLabel,
  classic,
  children,
}: {
  id: string;
  title: string;
  triggerLabel?: string;
  classic?: boolean;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleOpen = (event: Event) => {
      if ((event as CustomEvent<{ id: string }>).detail?.id === id)
        setOpen(true);
    };
    window.addEventListener("reweb-open-dialog", handleOpen);
    return () => window.removeEventListener("reweb-open-dialog", handleOpen);
  }, [id]);
  return (
    <>
      {triggerLabel && (
        <button
          type="button"
          className="re-action re-action-arrow"
          onClick={() => setOpen(true)}
        >
          {triggerLabel}
          <span aria-hidden>›</span>
        </button>
      )}
      <Dialog open={open} onClose={setOpen} className="re-content-dialog">
        <DialogBackdrop className="re-content-dialog-backdrop" />
        <div className="re-content-dialog-position">
          <DialogPanel
            className="re-content-dialog-panel"
            data-re-classic-dialog={classic ? "" : undefined}
          >
            <div className="re-content-dialog-heading">
              <DialogTitle>{title}</DialogTitle>
              <button
                type="button"
                aria-label="Luk"
                onClick={() => setOpen(false)}
              >
                ×
              </button>
            </div>
            {children}
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}
